export default {"src":"/_next/static/media/sol.6c678431.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};